import { Layer, Source } from 'react-map-gl';
import { isEmpty, sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';

import { mapViewSelector } from '../../../store/slices/mapViewSlice';
import { useAppSelector } from '../../../store/hooks';
import { useClientData } from '../../useClientData';
import { useGetClientSettingMapView } from '../useGetClientSettingMapView';

export const usePlantHealthAnalytics = ({ mapRef }: any) => {
  const { dataPlantHealth, isDisplayBoundaryLine, isLayer3D } = useAppSelector(mapViewSelector);

  const { getTopSurfaceOpacity, colorTransparent, isSameColorTopSurface, opacity2D, getOpacityExtrusion } =
    useGetClientSettingMapView();

  const { contourSetting } = useClientData();

  const polygonPlantHealthViewer = useCallback(
    (_item: any) => {
      return (
        <Source id={`${_item._id}_PlantHealth`} key={`${_item._id}_PlantHealth`} type="geojson" data={_item.geometry}>
          <Layer
            id={`${_item._id}-polygon_PlantHealth`}
            type="line"
            paint={{
              'line-color': _item.color,
              'line-opacity': isDisplayBoundaryLine ? 1 : 0,
              'line-width': 2,
            }}
            // source={`${_item._id}_PlantHealth`}
            layout={{ visibility: _item.visible ? 'visible' : 'none' }}
          />
          <Layer
            id={`${_item._id}_PlantHealth_fill-polygon`}
            type="fill"
            paint={{
              'fill-color': _item.color,
              'fill-opacity': !isLayer3D ? opacity2D : 0,
              'fill-antialias': true,
              'fill-translate-anchor': 'viewport',
            }}
            // source={`${_item._id}_PlantHealth`}
            layout={{ visibility: _item.visible && !isDisplayBoundaryLine ? 'visible' : 'none' }}
          />
          <Layer
            id={`${_item._id}_PlantHealth_top-surface`}
            type="fill-extrusion"
            // source={`${_item._id}_PlantHealth`}
            beforeId={`${_item._id}_PlantHealth_fill-polygon`}
            paint={{
              'fill-extrusion-color': _item.color,
              'fill-extrusion-height': contourSetting,
              'fill-extrusion-base': contourSetting,
              'fill-extrusion-opacity': getTopSurfaceOpacity,
              'fill-extrusion-vertical-gradient': true,
            }}
            layout={{ visibility: _item.visible && !isDisplayBoundaryLine ? 'visible' : 'none' }}
          />
          <Layer
            id={`${_item._id}_PlantHealth_side-surface`}
            type="fill-extrusion"
            beforeId={`${_item._id}_PlantHealth_top-surface`}
            // source={`${_item._id}_PlantHealth`}
            paint={{
              'fill-extrusion-color': isSameColorTopSurface ? _item.color : colorTransparent,
              'fill-extrusion-height': contourSetting,
              'fill-extrusion-base': 0,
              'fill-extrusion-opacity': getOpacityExtrusion,
              'fill-extrusion-vertical-gradient': true,
            }}
            layout={{ visibility: _item.visible && !isDisplayBoundaryLine ? 'visible' : 'none' }}
          />
        </Source>
      );
    },
    [
      colorTransparent,
      contourSetting,
      getOpacityExtrusion,
      getTopSurfaceOpacity,
      isDisplayBoundaryLine,
      isLayer3D,
      opacity2D,
      isSameColorTopSurface,
    ]
  );

  const layerPlantHealth = useMemo(() => {
    if (isEmpty(dataPlantHealth)) {
      return null;
    }

    return <>{sortBy(dataPlantHealth, 'type').map((_item) => polygonPlantHealthViewer(_item))}</>;
  }, [dataPlantHealth, polygonPlantHealthViewer]);

  return { layerPlantHealth };
};
